import { render, staticRenderFns } from "./DashboardCaskAging.vue?vue&type=template&id=56ca58f6&"
import script from "./DashboardCaskAging.vue?vue&type=script&lang=js&"
export * from "./DashboardCaskAging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports